import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { container } from '@src/container';
import type { AnalyticsService } from '@src/application/analytics/usecases/analytics.service';

/**
 * Hook to track page views automatically on route changes
 */
export function usePageTracking() {
    const location = useLocation();

    useEffect(() => {
        const analyticsService = container.resolve<AnalyticsService>('AnalyticsService');

        if (analyticsService.isInitialized()) {
            const path = location.pathname + location.search;
            const title = document.title;

            analyticsService.trackPageView({
                path,
                title,
                location: window.location.href,
                metadata: {
                    search: location.search,
                    hash: location.hash,
                },
            });
        }
    }, [location]);
}
